module.exports = __webpack_public_path__ + "img/banner1.0ff50791.jpg";